export const yodaAgentConstants = {
  GETAGENT_ALL_REQUEST: "YODAAGENT_GETAGENT_ALL_REQUEST",
  GETAGENT_ALL_SUCCESS: "YODAAGENT_GETAGENT_ALL_SUCCESS",
  GETAGENT_ALL_FAILURE: "YODAAGENT_GETAGENT_ALL_FAILURE",

  GETAGENT_ONE_REQUEST: "YODAAGENT_GETAGENT_ONE_REQUEST",
  GETAGENT_ONE_SUCCESS: "YODAAGENT_GETAGENT_ONE_SUCCESS",
  GETAGENT_ONE_FAILURE: "YODAAGENT_GETAGENT_ONE_FAILURE",
};
